import React from 'react'
import PropTypes from 'prop-types'

import queryGraphql from '@shared/components/queryGraphql'
import { CURRENT_MATCHES } from '@graphql/fixtures/fixtures.query'
import Error from '@shared/components/error'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { checkRedirectionStatus, getTimeZone, handleApiError } from '@shared-submodule/utils'
import dynamic from 'next/dynamic'
const CurrentMatches = dynamic(() => import('@shared/components/current-matches'))
const FixtureContent = dynamic(() => import('@shared/components/fixtureContent'))

function Fixtures({ data, seoData }) {
  return (
    <FixtureContent
      type="currentMatches"
      seoData={seoData}
    >
      <CurrentMatches data={data} status={'l'} />
    </FixtureContent>
  )
}

Fixtures.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object
}

export default Error(Fixtures)

export async function getServerSideProps({ res, resolvedUrl, query }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=5')

    const { allRoutes } = (await import('@shared-submodule/sm-constants/allRoutes'))
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.fixturesNew?.slice(1) } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const parallelCalls = (await import('@shared-submodule/utils')).parallelCalls
    const [international, league, domestic] = await parallelCalls([
      queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'i', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 50 } }),
      queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'l', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 50 } }),
      queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'd', eStatus: 'l', sTimezone: getTimeZone(), nSkip: 1, nLimit: 50 } })
    ])

    return {
      props: {
        data: { international, league, domestic },
        seoData: seoData?.getSeoData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
